<template>
  <dashboard-page />
</template>

<script>
import DashboardPage from '@/views/dashboard/index.vue'

// 菜单「数据概览」的组件路径为 business/dashboard/list，这里直接复用数据概览页实现
export default {
  name: 'DashboardList',
  components: { DashboardPage }
}
</script>
